







































































































import {Component, Vue, Prop} from 'vue-property-decorator';

@Component
export default class CenterProfile extends Vue {
    @Prop() public id!: string | number;

    get jobCorpCenter() {
        return this.$store.getters.getJobCorpsCenterById(this.id);
    }

    public getUserProfileName(id: number) {
        const user = this.$store.getters.getUserProfileById(id);
        if (user) {
            return `${user.getFullName()} ${user.active ? '' : ' (Inactive)'}`;
        } else {
            return '';
        }
    }
}
